import messages from './cmsRichText.json' with { type: 'json' };

export const cmsRichTextFi: Readonly<typeof messages> = messages;
